"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var meetsIsRequired = (value, isRequired) => isRequired ? value.length > 0 : true;
var validate = (value, isRequired) => {
  var isValid = true;
  // If field is required, then make sure some input is provided
  isValid = isValid && meetsIsRequired(value, isRequired);
  return isValid;
};
var HiddenField = props => {
  var {
    value = '',
    onChange = (value, isValid) => {},
    // eslint-disable-line no-unused-vars,
    isRequired = false,
    inputRef = /*#__PURE__*/_react.default.createRef()
  } = props;

  // Call onChange on mount so that if the field is not required, global validation state
  // can still be updated (field is valid regardless of input value)
  (0, _react.useEffect)(() => {
    onChange(value, validate(value, isRequired));
  }, [isRequired, onChange, value]);
  return /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    "aria-label": "hiddenBox",
    ref: inputRef,
    value: value,
    "data-di-mask": true
  });
};
HiddenField.propTypes = {
  onChange: _propTypes.default.func,
  value: _propTypes.default.string,
  isRequired: _propTypes.default.bool,
  inputRef: _propTypes.default.object
};
var _default = exports.default = HiddenField;